import React from 'react';
import { Radio, Typography, useTheme, styled, Box } from '@mui/material';
import RenderBaggageIcons from '@shared/pages/Flights/components/RenderBaggageIcons';
import {
  findScale,
  flightTimeConvertSimple,
  returnTime,
} from '@shared/helpers/flights/flights';
import SectionGrid from '@shared/components/SectionGrid';

const CSSRadio = styled(props => <Radio color="default" {...props} />)(
  ({ theme }) => ({
    color: '#E5E5E5',
    padding: 4,
    width: 24,
    height: 24,
    '&.Mui-checked': {
      color: theme.tertiary,
    },
  })
);

const HeaderAcordeonPersonalized = ({
  object_option,
  indexLeg,
  handleRadio,
  activeRadio,
  next_leg_options,
  next_cluster,
}) => {
  const theme = useTheme();

  const customLayout = {
    xs: { 1: 1.3, 2: 2.3, 3: 3, 4: 3, 5: 2.4 },
  };

  return (
    <SectionGrid
      spacing={1}
      padding="8px"
      customLayout={customLayout}
      gridSx={{ alignItems: 'center' }}
    >
      {/* 1. Radio */}
      <CSSRadio
        checked={activeRadio}
        onClick={e => {
          e.stopPropagation();
          handleRadio(indexLeg, object_option, next_leg_options, next_cluster);
        }}
      />

      {/* 2. Hora de salida */}
      <Typography sx={{ color: '#000', fontSize: { xs: '14px', sm: '14px' } }}>
        {returnTime(object_option?.departure)}
      </Typography>

      {/* 3. Tiempo de vuelo */}
      <Typography
        sx={{
          color: theme.tertiary,
          fontWeight: 600,
          fontSize: { xs: '14px', sm: '14px' },
        }}
      >
        {flightTimeConvertSimple(object_option?.flight_time)}
      </Typography>

      {/* 4. Escalas */}
      <Typography sx={{ color: '#000', fontSize: { xs: '14px', sm: '14px' } }}>
        {findScale(object_option)}
      </Typography>

      {/* 5. Baggage */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'start',
          width: '100%',
          height: { xs: '45px', sm: '42px' },
          overflow: 'hidden',
        }}
      >
        <RenderBaggageIcons
          baggage={object_option?.flight_baggage}
          mt={{ xs: '-8px' }}
          transform={{ xs: 'scale(0.75)', sm: 'scale(0.65)' }}
          transformOrigin="center left"
        />
      </Box>
    </SectionGrid>
  );
};

export default HeaderAcordeonPersonalized;
